export default "__VITE_ASSET__BPCmiT_G__"